import { useEffect, useState } from 'react';
import moment from 'moment';

const useCalendarView = () => {
  const [dateInView, setDateInView] = useState(moment());
  const [monthsInView, setMonthsInView] = useState([
    moment(dateInView).month(),
    moment(dateInView).add(1, 'month').month()
  ]);

  const handleMonthChange = newMonth => {
    const newMonthsInView = [
      newMonth.month(),
      newMonth.clone().add(1, 'month').month()
    ];
    setMonthsInView(newMonthsInView);
  };

  useEffect(() => {
    handleMonthChange(moment(dateInView));
  }, [dateInView]);

  return {
    dateInView,
    setDateInView,
    monthsInView,
    handleMonthChange
  };
};

export default useCalendarView;
